import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, createLazyComponent, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FeedbackSdkApi" */ './lazyIndex'),
    { name: 'FeedbackSdkApi' }
);

// Export the manager component to be rendered at app root
export const FeedbackDialogManager: LazyComponent<{}, unknown> = createLazyComponent(
    lazyModule,
    m => m.FeedbackDialogManager
);

// Export actions to trigger the dialog
export { showFeedbackDialog } from './actions/showFeedbackDialog';

export const lazyGetFeedbackComplianceChecks: LazyImport<
    typeof lazyIndex.getFeedbackComplianceChecks,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFeedbackComplianceChecks);

export type { ContextDataFile, IFeedbackInitOptions } from './schema/FeedbackTypes';
export type { FeedbackDialogProps } from './schema/feedbackDialogProps';
